import { createContext } from 'react';
import { getWorkspaceSettings, updateWorkspaceSettings, WorkspaceSettingsDTO } from 'wisestep-api';

import { useFetch } from '../../hooks/useFetch';

interface IWorkspaceSettingsContext {
  workspaceSettings: WorkspaceSettingsDTO;
  updateDefaultTAndC(defaultInvoiceTAndC: string): void;
}

export const WorkspaceSettingsContext = createContext<IWorkspaceSettingsContext>(
  {} as IWorkspaceSettingsContext
);

function WorkspaceSettingsContextProvider({ children }) {
  const [workspaceSettings, setWorkspaceSettings] = useFetch(getWorkspaceSettings);

  const updateDefaultTAndC = (defaultInvoiceTAndC: string) => {
    updateWorkspaceSettings({ defaultInvoiceTAndC } as WorkspaceSettingsDTO).then((response) =>
      setWorkspaceSettings(response.data)
    );
  };

  return workspaceSettings ? (
    <WorkspaceSettingsContext.Provider value={{ workspaceSettings, updateDefaultTAndC }}>
      {children}
    </WorkspaceSettingsContext.Provider>
  ) : null;
}

export default WorkspaceSettingsContextProvider;
